import React from "react";
import { Bar } from "react-chartjs-2";

const StatisticsCard = ({ title, totalVisitors, graphData }) => {
  return (
    <div className="border-2 border-gray-200 rounded-lg p-4">
      <div className="text-2xl font-bold mb-4">{title} {totalVisitors}</div>
      {/* <div className="text-4xl font-bold">{totalVisitors}</div> */}
      <div className="mt-2">
        <div className="w-full h-[300px]">
          {" "}
          {/* Full width and adjusted height */}
          <Bar
            data={{
              labels: graphData.labels,
              datasets: [
                {
                  label: "Total Visitors",
                  data: graphData.data,
                  backgroundColor: graphData.barColor,
                },
              ],
            }}
            options={{
              plugins: { legend: { display: false } },
              maintainAspectRatio: false, // Disable aspect ratio to use custom dimensions
              responsive: true, // Make the chart responsive
              scales: { y: { beginAtZero: true } },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default StatisticsCard;
